import { StyledButton } from "./Button.styles"
// @ts-ignore
import AddIcon from "../../icon/addIcon.svg?react"
// @ts-ignore
import BackIcon from "./icon.svg?react"
// @ts-ignore
import DeleteIcon from "../../icon/deleteIcon.svg?react"
// @ts-ignore
import GearIcon from "../../icon/gearIcon.svg?react"
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
// @ts-ignore
import LogoutIcon from "../../icon/logout.svg?react";

type Icon = "add" | "back" | "delete" | "gear" | "download" | "logout"

export interface Props {
  label?: string
  variant?: "outlined" | "contained" | "textOnly"
  onClick?: () => void
  icon?: Icon
  color?: string
  colorSecondary?: string
  disabled?: boolean
  sx?: {}
}

function passVariant(
  variant: string | undefined,
): "text" | "outlined" | "contained" | undefined {
  if (["outlined", "contained"].includes(variant!)) {
    return variant as "outlined" | "contained"
  }
  return undefined as undefined
}

function passIcon(icon: Icon | undefined): React.ReactNode | undefined {
  const Component =
    icon &&
    {
      add: AddIcon,
      back: BackIcon,
      delete: DeleteIcon,
      gear: GearIcon,
      download: FileDownloadOutlinedIcon,
      logout: LogoutIcon
    }[icon]

  if (!Component) {
    return undefined
  }

  return <Component />
}

export default function Button({
  onClick,
  variant,
  icon,
  color,
  colorSecondary,
  disabled,
  label,
  ...props
}: Props) {
  return (
    <StyledButton
      label={label}
      onClick={onClick}
      variant={passVariant(variant)}
      stylevariant={variant}
      startIcon={passIcon(icon)}
      overrideColor={color}
      overrideColorSecondary={colorSecondary}
      disabled={disabled || false}
      {...props}
    >
      {label}
    </StyledButton>
  )
}
